<template>
  <div>
    <v-row class="gallery-component-row">
      <v-col
        v-for="(image, i) in image_links"
        :key="`${id}-image${i}`"
        :cols="`${cols || 3}`"
        :style="`padding: ${padding || 2}px !important`"
      >
        <v-img
          class="gallery-component-img"
          :style="`border-radius: ${border_radius || 0}px;`"
          aspect-ratio="1"
          :src="image"
          v-ripple
          @click="$emit('emittedClick', image)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  // TODO: image_links needs to be an array of objects with links (string) and id (number)
  export default {
    props: [
      'image_links', // is array of strings, contains links to image_links
      'id', // is string, identifier of gallery - should be generated by loop
      'border_radius', // is number, determins border-radius of image
      'padding', // is number,
      'cols', // is number,
    ],

    data: () => ({

    }),

    methods: {

    }
  }
</script>

<style>
  .gallery-component-row {
    margin: 0 !important;
    padding-top: 8px;
  }
  .gallery-component-img {
    cursor: pointer;
  }
</style>
